import React from "react";

import { Outlet } from "react-router-dom";

import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import BackToTop from "../components/BackToTop";
import { Box } from "@mui/material";

function MainLayout() {
  return (
    <>
      <Navbar />

      <main>
        <Outlet />
      </main>

      <Footer />
      <BackToTop />
      <Box
        sx={{
          position: "absolute",
          left: "-9999px",
          opacity: 0,
          pointerEvents: "none",
        }}
      >
        Professional dry cleaning services in Ajax, Ontario. Wedding dress
        cleaning, alterations, laundry service, rug cleaning, shoe repair,
        handbag cleaning, leather cleaning, fur cleaning and pickup delivery
        service in Ajax, Pickering and Whitby.
      </Box>
    </>
  );
}

export default MainLayout;
